import apiClient from '@u/apiClient'
import DuplicateDocumentV3Controller from '@/wayfinder/actions/App/Http/Controllers/Document/Editor/DuplicateDocumentV3Controller'
import DownloadBlankWikiDocumentController from '@/wayfinder/actions/App/Http/Controllers/WikiDocument/DownloadBlankWikiDocumentController'
import { apiPath } from '@u/apiPath'
import { helper } from '@u/helper'
import { contentDispositionFilename } from '@u/http/contentDispositionFilename'

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  async deleteWikiDocumentById({ commit }, payload) {
    const url = payload.type
      ? `wiki-document/delete/${payload.wiki_document_id}/?type=${payload.type}`
      : `wiki-document/delete/${payload.wiki_document_id}`
    await apiClient
      .delete(apiPath(url))
      .then(async (response) => {
        if (response.status === 200) {
          if (payload.type) {
            commit('setPlaceList', response.data.places)
          } else {
            await commit('setCity', response.data.wiki_city)
          }
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('deleteWikiItemById', reason)
      })
  },
  async duplicateWikiDocumentById({ commit }, payload) {
    await apiClient
      .route(
        DuplicateDocumentV3Controller.post({
          type: 'wikidocument',
          document: payload.wiki_document_id
        })
      )
      .then(async (response) => {
        if (response.status === 200) {
          if (payload.type) {
            commit('setPlaceList', response.data.places)
          } else {
            await commit('setCity', response.data.wiki_city)
          }
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('duplicateWikiDocumentById', reason)
      })
  },
  // The API renders the template with an empty dossier and names the PDF
  // after the document shown in the Wiki. A 422 (template not renderable) is
  // toasted by the apiClient error hook.
  async downloadBlankWikiDocument(_context, payload) {
    await apiClient
      .route(
        DownloadBlankWikiDocumentController.get({
          wiki_document: payload.wiki_document_id
        }),
        { responseType: 'blob' }
      )
      .then((response) => {
        const url = URL.createObjectURL(response.data)
        helper.downloadURI(
          url,
          contentDispositionFilename(
            response.headers.get('content-disposition'),
            'document.pdf'
          )
        )
        // Firefox drops the download if the URL is revoked during the click.
        setTimeout(() => URL.revokeObjectURL(url))
      })
      .catch((reason) => {
        console.error('downloadBlankWikiDocument', reason)
      })
  },
  async undoDeleteWikiDocumentById({ commit }, payload) {
    const url = payload.type
      ? `wiki-document/undo-delete/${payload.wiki_document_id}/?type=${payload.type}`
      : `wiki-document/undo-delete/${payload.wiki_document_id}`
    await apiClient
      .get(apiPath(url))
      .then(async (response) => {
        if (response.status === 200) {
          console.log(payload.type)
          if (payload.type) {
            commit('setPlaceList', response.data.places)
          } else {
            await commit('setCity', response.data.wiki_city)
          }
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('undoDeleteWikiItemById', reason)
      })
  }
}
